<template>
  <v-card flat>
    <v-toolbar flat dense color="theme_primary" class="white--text">
      <v-spacer></v-spacer>
      <v-toolbar-title class="white-text">New demand</v-toolbar-title>

      <v-spacer></v-spacer>
      <v-toolbar-side-icon>
        <v-icon @click="closeParentDialog()" color="white">close</v-icon>
      </v-toolbar-side-icon>
    </v-toolbar>
    <v-card-text>
      <v-stepper v-model="activeStep" vertical>
        <!-- Customer -->
        <v-stepper-step
          :editable="activeStep > 1"
          edit-icon="check"
          :complete="activeStep > 1"
          step="1"
        >
          Select a Customer
          <small v-if="newDemand.company_id">{{
            getCustomerName(newDemand.company_id)
          }}</small>
        </v-stepper-step>

        <v-stepper-content step="1">
          <v-autocomplete
            :items="customers"
            item-value="id"
            item-text="name"
            v-model="newDemand.company_id"
            background-color="white"
            @input="selectedCustomer"
            box
            label="Customer"
            prepend-icon="store"
          ></v-autocomplete>
          <!-- <v-btn @click="debugSkip">SKIP DEBUG</v-btn> -->
        </v-stepper-content>

        <!-- Payment Settings -->
        <v-stepper-step
          :editable="activeStep > 2"
          edit-icon="check"
          :complete="activeStep > 2"
          step="2"
        >
          Payment Settings
          <small v-if="getIncotermSettings()">{{
            getIncotermSettings()
          }}</small>
        </v-stepper-step>

        <v-stepper-content step="2">
          <v-autocomplete
            :items="incoterms"
            item-value="id"
            item-text="name"
            v-model="newDemand.incoterm_id"
            background-color="white"
            box
            label="Incoterm"
            prepend-icon="event_note"
          ></v-autocomplete>
          <v-btn
            :disabled="!newDemand.incoterm_id"
            small
            color="primary"
            @click="activeStep = 3"
            >Continue</v-btn
          >
        </v-stepper-content>

        <!-- Port -->
        <v-stepper-step
          :editable="activeStep > 3"
          edit-icon="check"
          :complete="activeStep > 3"
          step="3"
        >
          Select a Port
          <small v-if="newDemand.port_id">{{ getPortName() }}</small>
        </v-stepper-step>

        <v-stepper-content step="3">
          <v-autocomplete
            :items="ports"
            item-value="id"
            item-text="name"
            v-model="newDemand.port_id"
            background-color="white"
            clearable
            box
            label="Port"
            prepend-icon="directions_boat"
          ></v-autocomplete>
          <v-btn
            :disabled="!newDemand.port_id"
            small
            color="primary"
            @click="activeStep = 4"
            >Continue</v-btn
          >
        </v-stepper-content>

        <!-- Add Product -->
        <v-stepper-step edit-icon="check" :complete="activeStep > 4" step="4"
          >Add a Product</v-stepper-step
        >

        <v-stepper-content step="4">
          <v-autocomplete
            :disabled="!newDemand.company_id"
            :items="products"
            item-value="id"
            item-text="name"
            v-model="productPackagings[productPackagings.length - 1].product_id"
            background-color="white"
            box
            label="Product"
            prepend-icon="shopping_cart"
          ></v-autocomplete>

          <v-autocomplete
            :disabled="
              !newDemand.company_id ||
              !productPackagings[productPackagings.length - 1].product_id
            "
            :items="
              fetchPackagings(
                productPackagings[productPackagings.length - 1].product_id
              )
            "
            item-value="id"
            item-text="name"
            v-model="
              productPackagings[productPackagings.length - 1].packaging_ids
            "
            background-color="white"
            multiple
            box
            label="Packaging(s)"
            prepend-icon="mdi-package-variant"
          ></v-autocomplete>

          <v-btn
            :disabled="
              !newDemand.company_id ||
              !productPackagings[productPackagings.length - 1].product_id
            "
            color="primary"
            small
            @click="activeStep = 5"
            >Continue</v-btn
          >
        </v-stepper-content>
        <!-- Validation -->
        <v-stepper-step
          :editable="productPackagings.length > 1"
          edit-icon="check"
          :complete="activeStep > 5"
          step="5"
          >Validation</v-stepper-step
        >

        <v-stepper-content step="5">
          <v-card v-if="newDemand.company_id" class="elevation-4">
            <v-toolbar flat color="theme_primary_lighten1" height="36" dark>
              <v-icon small class="pr-2">flight_land</v-icon>
              <span class="subheadings">New demand Preview</span>
            </v-toolbar>
            <v-card-title class="pb-0">
              <span>
                <v-icon small class="pr-2" color="primary">store</v-icon>
                <span>Customer:</span>
                <span class="grey--text pl-2">{{
                  getCustomerName(newDemand.company_id)
                }}</span>
                <br />
                <v-icon small class="pr-2" color="primary">event_note</v-icon>
                <span>Incoterm:</span>
                <span class="grey--text pl-2">{{
                  newDemand.incoterm_id
                    ? getObjName(incoterms, newDemand.incoterm_id)
                    : "No."
                }}</span>
                <br />
                <v-icon small class="pr-2" color="primary"
                  >directions_boat</v-icon
                >
                <span>Port:</span>
                <span class="grey--text pl-2">{{
                  getObjName(ports, newDemand.port_id)
                }}</span>
              </span>
            </v-card-title>
            <v-card-text class="pt-0">
              <v-subheader>
                Product(s)
                <v-spacer></v-spacer>
                <v-tooltip left>
                  <div slot="activator">
                    <v-btn
                      icon
                      small
                      color="primary"
                      depressed
                      @click="addProductPackagings"
                    >
                      <v-icon small>add</v-icon>
                    </v-btn>
                  </div>
                  <span>Add a new product to the demand</span>
                </v-tooltip>
              </v-subheader>
              <v-flex class="pb-4">
                <v-expansion-panel light class="mini">
                  <template v-for="(pp, index) in productPackagings">
                    <v-expansion-panel-content
                      v-if="pp.product_id"
                      :key="pp.id"
                    >
                      <template v-slot:header>
                        <span>
                          <v-icon small color="grey lighten1"
                            >shopping_cart</v-icon
                          >
                          {{
                            truncateBreakpoint(
                              getObjName(products, pp.product_id)
                            )
                          }}
                        </span>
                      </template>
                      <v-card>
                        <v-card-text>
                          <v-container grid-list-md text-xs-center class="pa-0">
                            <v-layout row wrap>
                              <v-flex
                                xs3
                                md3
                                v-for="pck in pp.packaging_ids"
                                :key="pck"
                                justify-center
                              >
                                <div class="text-xs-center">
                                  <v-flex xs12>
                                    <v-icon
                                      style="-webkit-text-stroke: 2px white;"
                                      color="grey lighten-"
                                      size="44"
                                      >mdi-package-variant</v-icon
                                    >
                                  </v-flex>
                                  <v-flex xs12>
                                    <span>{{ getPackagingName(pck) }}</span>
                                  </v-flex>
                                </div>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            small
                            flat
                            color="error"
                            @click="removeProduct(index)"
                          >
                            Remove product from demand
                            <v-icon small class="pl-2">delete</v-icon>
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-expansion-panel-content>
                  </template>
                </v-expansion-panel>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-stepper-content>
      </v-stepper>
    </v-card-text>
    <v-card-actions>
      <v-btn
        :disabled="!(activeStep == 5)"
        block
        color="success"
        @click="createDemand"
      >
        <v-icon class="pr-2" small>save</v-icon>Save new demand
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import CREATE_DEMAND from "../../graphql/demands/create.gql";
import COMPANY_SHOW_PRODUCTS from "../../graphql/companies/show_products.gql";
export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      activeStep: 1,
      products: [],
      ports: [],
      commercialProducts: [],
      incoterms: [],
      productPackagings: [{ product_id: "", packaging_ids: [] }],
      newDemand: {
        name: "",
        incoterm_id: "",
        company_id: "",
        port_id: "",
      },
    };
  },
  computed: {
    ...mapGetters("commonStore", [
      "productsSupplierCompanies",
      "customers",
      "packagings",
    ]),
  },
  methods: {
    debugSkip() {
      this.newDemand.company_id = this.productsSupplierCompanies[0].id;
      this.selectedCustomer(this.newDemand.company_id);
      this.newDemand.port_id = this.ports[0].id;
      this.newDemand.incoterm_id = this.incoterms[0].id;
      this.productPackagings = [
        {
          product_id: this.products[0].id,
          packaging_ids: [],
        },
      ];
      this.activeStep = 5;
    },
    removeProduct(index) {
      if (this.productPackagings.length > 1)
        this.productPackagings.splice(index, 1);
      else {
        this.productPackagings[0].product_id = "";
        this.productPackagings[0].packaging_ids = [];
        this.activeStep = 4;
      }
    },
    getPackagingName(pck) {
      return this.packagings.find((p) => p.id == pck).name;
    },
    addProductPackagings() {
      this.productPackagings = this.productPackagings.concat({
        product_id: "",
        packaging_ids: [],
      });
      this.activeStep = 4;
    },
    truncateBreakpoint(input) {
      if (this.$vuetify.breakpoint.xs && input.length > 25)
        return input.substring(0, 25) + "...";

      if (this.$vuetify.breakpoint.sm && input.length > 40)
        return input.substring(0, 40) + "...";

      return input.substring(0, 80) + "...";
    },
    getPackagingNames(product) {
      if (product && product.packaging_ids.length > 0)
        return product.packaging_ids
          .map((id) => this.packagings.find((p) => p.id == id).name)
          .join(", ");
      else return "No packagings";
    },
    fetchPackagings(id) {
      return this.commercialProducts
        .filter((e) => e.product.id == id)
        .map((e) => e.packagings)
        .flat();
    },
    getCustomerName(id) {
      var res = this.customers.filter((o) => {
        if (o.id === id) return o;
      });
      if (res[0] == undefined) return "Customer name not found";
      return res[0].name;
    },
    getObjName(obj, id) {
      if (obj == undefined || id == undefined || id == "") return "";
      var res = obj.filter((o) => {
        if (o.id === id) return o;
      });

      return res[0].name;
    },
    getIncotermSettings() {
      var str = "";
      str += this.newDemand.incoterm_id
        ? "Incoterm: " +
          this.getObjName(this.incoterms, this.newDemand.incoterm_id) +
          " "
        : "No incoterm.";

      return !this.newDemand.incoterm_id ? "" : str;
    },
    getPortName() {
      var str = "";
      str += this.newDemand.port_id
        ? "Port: " + this.getObjName(this.ports, this.newDemand.port_id) + " "
        : "No port.";
      return !this.newDemand.port_id ? "" : str;
    },
    closeParentDialog() {
      this.$emit("update:dialog", false);
    },
    resetDemand() {
      this.newDemand = {
        name: "",
        incoterm_id: "",
        company_id: "",
        port_id: "",
      };
      this.activeStep = 1;
    },
    createDemand() {
      const variables = {
        ...this.newDemand,
        product_packagings_entities: this.productPackagings,
      };

      this.sendMutation("created", "demand", CREATE_DEMAND, variables).then(
        () => {
          this.resetDemand();
          this.closeParentDialog();
        }
      );
    },
    selectedCustomer(id) {
      this.productPackagings = [{ product_id: "", packaging_ids: [] }];

      this.newDemand.port_id = "";
      this.newDemand.incoterm_id = "";

      this.sendQuery(COMPANY_SHOW_PRODUCTS, { id }).then((data) => {
        this.commercialProducts = data.company.company_contacts
          .map((c) => c.commercial_zones)
          .flat()
          .map((c) => c.commercial_products)
          .flat();

        this.ports = data.company.customer.ports;
        this.incoterms = data.company.customer.incoterms;

        this.products = this.commercialProducts.map((e) => e.product);
      });
      this.activeStep = 2;
    },
  },
};
</script>
<style lang="stylus">
.mini {
  .v-expansion-panel__container--active > .v-expansion-panel__header {
    background-color: #f1f1f1 !important;
    color: black !important;
  }

  .v-expansion-panel__header {
    min-height: 0;
    padding: 3px 24px !important;
  }

  tbody {
    tr {
      height: 60px !important;

      td {
        height: 20px !important;
      }
    }
  }
}
</style>
